/**
 * Chat grid: one chat fills the area, two sit side by side, three or four form a 2-column grid, five or
 * more use 3 columns. Below `lg` everything stacks in one column. Class names are literal so Tailwind
 * can see them.
 */
export function gridClass(count: number): string {
  if (count <= 1) return 'grid-cols-1';
  if (count <= 4) return 'grid-cols-1 lg:grid-cols-2';
  return 'grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3';
}

/** With an odd number of panes in a 2-column grid the last one spans the full row. */
export function cellClass(index: number, count: number): string {
  return count === 3 && index === 2 ? 'lg:col-span-2' : '';
}
